import Phaser from 'phaser';

const BG_OUTER = 0x0a0f1f;
const BG_INNER = 0x1e293b;
const CLUB_DARK = 0x991b1b;
const CLUB_HIGHLIGHT = 0xfecaca;
const STROKE = 0xffffff;

export function drawBillyclub(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  g.fillStyle(CLUB_DARK, 0.5);
  g.fillRoundedRect(-r * 0.15, -r * 0.7, r * 0.3, r * 1.4, r * 0.12);

  const axisAngle = -Math.PI / 4;
  const len = r * 1.2;
  const w = r * 0.28;

  drawRotatedClub(g, axisAngle, len, w);
  drawRotatedClub(g, axisAngle + Math.PI / 2, len, w);

  g.fillStyle(CLUB_HIGHLIGHT, 0.7);
  g.fillCircle(0, 0, r * 0.14);
}

function drawRotatedClub(
  g: Phaser.GameObjects.Graphics,
  angle: number,
  len: number,
  w: number,
) {
  const c = Math.cos(angle);
  const s = Math.sin(angle);
  const pts: { x: number; y: number }[] = [];
  const half = len / 2;
  const corners = [
    { x: -half, y: -w / 2 },
    { x: half, y: -w / 2 },
    { x: half, y: w / 2 },
    { x: -half, y: w / 2 },
  ];
  for (const p of corners) {
    pts.push({ x: p.x * c - p.y * s, y: p.x * s + p.y * c });
  }
  g.fillStyle(0xef4444, 1);
  g.beginPath();
  g.moveTo(pts[0].x, pts[0].y);
  for (let i = 1; i < pts.length; i++) g.lineTo(pts[i].x, pts[i].y);
  g.closePath();
  g.fillPath();

  g.lineStyle(2, 0x0a0f1f, 1);
  g.strokePath();

  const capR = w * 0.85;
  g.fillStyle(0xdc2626, 1);
  g.fillCircle(half * c, half * s, capR);
  g.lineStyle(2, 0x0a0f1f, 1);
  g.strokeCircle(half * c, half * s, capR);
  g.fillCircle(-half * c, -half * s, capR);
  g.strokeCircle(-half * c, -half * s, capR);
}
